export default __webpack_public_path__ + "static/media/tag-icon-singles.ea691880.svg";